import { Button, Dialog, Spinner } from 'Components/Core';
import { actions } from 'Data/ReduxViewModels/InterLab';
import { hasValue } from 'Lib/Any';
import deepEquals from 'Lib/Object/deepEquals';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { InterLabCopyHistoryTable } from './CopyHistoryTable';
import { InterLabTransferHistoryTable } from './TransferHistoryTable';
import './ViewHistoryDialog.scss';

const InterLabViewHistoryDialog = () => {
  const dispatch = useDispatch();
  const isBusy = useSelector((state) => state.interLab.status.busy);

  const workOrderUuid = useSelector((state) => state.interLab.workOrder?.id);
  const workOrderId = useSelector((state) => state.interLab.workOrder?.workOrderId);
  const actionHistories = useSelector((state) => state.interLab.workOrder?.actionHistories ?? [], deepEquals);

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    dispatch(actions.getActionHistory(workOrderUuid!));
    setOpen(true);
  };

  return (
    <>
      <Button disabled={!hasValue(workOrderUuid)} primary onClick={handleOpen} loading={isBusy}>
        View History
      </Button>
      <Dialog
        className="ViewHistoryDialog"
        visible={open}
        width="75%"
        minHeight="200px"
        title={workOrderId}
        buttons={[
          <Button primary onClick={() => setOpen(false)}>
            Close
          </Button>,
        ]}
      >
        {isBusy ? (
          <Spinner large />
        ) : (
          <>
            <InterLabTransferHistoryTable transferHistories={actionHistories.filter((h) => !h.isCopy)} />
            <InterLabCopyHistoryTable copyHistories={actionHistories.filter((h) => h.isCopy)} />
          </>
        )}
      </Dialog>
    </>
  );
};

export { InterLabViewHistoryDialog };
